import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      name: 'เมนู',
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    user: {
      name: 'ผู้ทำรายการ',
      width: '12rem',
      class: {
        cell: 'text-right',
        text: 'text-right',
      },
      filter: (val: any) => val?.name || '-',
    },
    timestamp: {
      name: 'วันทำรายการ',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
  },

  sortable: [
    'type',
    'code',
    'updated_at',
  ],
};
